// extracted by mini-css-extract-plugin
module.exports = {"child":"style_child__feZjN","cake-box":"style_cake-box__zLN9L","swiperbox":"style_swiperbox__zwt8E"};